import { InformationCircleSolid } from '@medusajs/icons';
import { clx, Tooltip } from '@medusajs/ui';

interface CheckoutFormItemProps {
  title: string;
  value: string | null;
  tooltip?: string;
  valueClassName?: string;
  'data-testid'?: string;
}

const CheckoutFormItem = ({
  title,
  value,
  tooltip,
  valueClassName,
  'data-testid': testId,
}: CheckoutFormItemProps) => {
  return (
    <div className="flex items-center justify-between" data-testid={testId}>
      <div className="flex items-center gap-1">
        <span className="text-black-10">{title}</span>
        {tooltip && (
          <Tooltip content={tooltip} className="rounded-md">
            <InformationCircleSolid className="text-black-10" />
          </Tooltip>
        )}
      </div>
      <span className={clx('text-black-40', valueClassName)}>
        {value || '-'}
      </span>
    </div>
  );
};

export default CheckoutFormItem;
